import React from 'react';
import Avatar from '../../atoms/Avatar/Avatar';

const FounderBlock: React.FC = () => (
    <>
        <div className="relative mx-auto flex max-w-3xl flex-col text-base">
            <div className="relative">
                {/* Avatar */}
                <div className="relative flex w-full justify-end xl:top-10">
                    <Avatar imageStyle="private" />
                </div>

                <div className="font-serif text-2xl">Adrian Stanek</div>
                <div className="font-serif text-secondary-dark">CTO @ webbar.dev</div>

                <div className="relative mt-3 flex flex-wrap break-words text-sm tracking-wide text-gray-500">
                    Web Developer with passion for frontend, DevOps and solution architectures and
                    always looking for new ways to optimize solution approaches.
                </div>
            </div>
        </div>
    </>
);

export default FounderBlock;
